import { render, staticRenderFns } from "./BINCard.vue?vue&type=template&id=0a714233&lang=pug&"
import script from "./BINCard.vue?vue&type=script&lang=js&"
export * from "./BINCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports